import { cn } from "@/lib/utils";
import { ReactNode, useEffect, useRef, useState } from "react";

export interface MarqueeProps {
    children: ReactNode;
    className?: string;
    play?: boolean;
    speed?: number;
}

const Marquee = ({
    children,
    className,
    play = true,
    speed = 50,
}: MarqueeProps) => {
    const contentRef = useRef<HTMLDivElement>(null);
    const [contentWidth, setContentWidth] = useState(0);

    useEffect(() => {
        const content = contentRef.current;
        if (!content || typeof ResizeObserver === "undefined") return undefined;

        const observer = new ResizeObserver(() =>
            setContentWidth(content.getBoundingClientRect().width),
        );
        observer.observe(content);

        return () => observer.disconnect();
    }, []);

    const contentStyle = {
        animationDuration: `${contentWidth / speed}s`,
        animationPlayState: play ? "running" : "paused",
    };

    return (
        <div className={cn("flex w-full overflow-hidden", className)}>
            <div
                className="flex-none animate-marquee"
                ref={contentRef}
                style={contentStyle}
            >
                {children}
            </div>
            <div className="flex-none animate-marquee" style={contentStyle}>
                {children}
            </div>
        </div>
    );
};

export default Marquee;
